import styled from '@emotion/styled';
import LoaderBase from '@/components/atoms/Loader';

export const Loader = styled(LoaderBase)`
    font-size: 40px;
    coor: ${({ theme }) => theme.color.primary};
`;
